import { FaMoon, FaSun } from "react-icons/fa";
import useDarkMode from "../hooks/useDarkMode";

export default function DarkToggle() {
    const [dark, setDark] = useDarkMode();

    return (
        <button
            onClick={() => setDark(!dark)}
            className="
        p-2
        rounded-full
        border
        border-gray-300
        dark:border-gray-700
        text-gray-700
        dark:text-gray-200
        hover:bg-gray-100
        dark:hover:bg-gray-800
        transition
      "
            aria-label="Toggle dark mode"
        >
            {dark ? <FaSun size={16} /> : <FaMoon size={16} />}
        </button>
    );
}
